'use strict';

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookie = function () {
    function Cookie() {
        _classCallCheck(this, Cookie);

        this.raw = false;
    }

    Cookie.prototype.encode = function encode(s) {
        return this.raw ? s : encodeURIComponent(s);
    };

    Cookie.prototype.decode = function decode(s) {
        return this.raw ? s : decodeURIComponent(s);
    };

    Cookie.prototype.set = function set(key, value) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var pair = this.encode(key) + '=' + this.encode(value);
        var expires = options.expires ? '; expires=' + computeExpires(options.expires) : '';
        var path = options.path ? '; path=' + options.path : '';
        var domain = options.domain ? '; domain=' + options.domain : '';
        var secure = options.secure ? '; secure' : '';
        var cookie = '' + pair + expires + path + domain + secure;
        document.cookie = cookie;
        return cookie;
    };

    Cookie.prototype.get = function get(key) {
        if (!key || typeof key !== 'string') {
            return null;
        }

        var pairs = document.cookie ? document.cookie.split('; ') : [];
        for (var i = 0; i < pairs.length; i++) {
            var _pairs$i$split = pairs[i].split('='),
                k = _pairs$i$split[0],
                v = _pairs$i$split[1];

            if (this.encode(key) === k) {
                return this.decode(v);
            }
        }

        return null;
    };

    Cookie.prototype['delete'] = function _delete(key) {
        this.set(key, '', { expires: new Date(0) });
    };

    return Cookie;
}();

// Return a future date by the given string.


exports['default'] = Cookie;
function computeExpires(expires) {
    var newExpires = void 0;

    if (expires instanceof Date) {
        newExpires = expires;
    } else {
        if (typeof expires === 'number') {
            expires = expires + 'D';
        } else {
            expires = String(expires);
        }

        var lastChar = expires.charAt(expires.length - 1);
        var num = parseInt(expires, 10);
        newExpires = new Date();

        switch (lastChar) {
            case 'Y':
                newExpires.setFullYear(newExpires.getFullYear() + num);
                break;
            case 'M':
                newExpires.setMonth(newExpires.getMonth() + num);
                break;
            case 'D':
                newExpires.setDate(newExpires.getDate() + num);
                break;
            case 'h':
                newExpires.setHours(newExpires.getHours() + num);
                break;
            case 'm':
                newExpires.setMinutes(newExpires.getMinutes() + num);
                break;
            case 's':
                newExpires.setSeconds(newExpires.getSeconds() + num);
                break;
            default:
                newExpires = new Date(expires);
                break;
        }
    }

    return newExpires.toUTCString();
}
module.exports = exports['default'];